import { faEye, faFile } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format, parseISO } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import BootstrapSwitchButton from '../bootstrap-switch-button/bootstrap-switch-button-react';

export type RowClickedFunction = (data: any) => void;
//export const EyeColumn = (rowClicked: RowClickedFunction, id = 'select') => {
export function EyeColumn(rowClicked: RowClickedFunction, id = 'select') {
  return {
    // ΚΟΛΩΝΑ ΜΕ RedEye και Click handler
    id,
    Header: () => <FontAwesomeIcon icon={faFile} />,
    Cell: ({ row }) => (
      <div
        className="text-center"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          rowClicked(row.original);
        }}
      >
        <FontAwesomeIcon icon={faEye} />
      </div>
    ),
    width: '5',
  };
}

/*
  const isActiveChanged = useCallback((checked, row) => {    console.log(checked, row.id);  }, []);

  { Header: 'Ενεργή', accessor: 'isActive', Cell: CellCheckbox(isActiveChanged), },
*/
export function CellCheckbox(
  checkboxChanged,
  disabled = false,
  onStyle = undefined,
  offStyle = undefined,
) {
  const { t } = useTranslation();
  return (data) => {
    return (
      <div className="text-center">
        <BootstrapSwitchButton
          checked={data?.cell?.value || false}
          onlabel={t('Yes')}
          offlabel={t('No')}
          width="80"
          onstyle={onStyle ? onStyle : disabled ? 'dark' : 'primary'}
          offstyle={offStyle ? offStyle : disabled ? 'light' : 'warning'}
          disabled={disabled}
          onChange={(checked: boolean) => {
            checkboxChanged(checked, data?.row?.original);
          }}
        />
      </div>
    );
  };
}

export const CellDefault = ({ cell: { value } }) => (
  <div style={{ paddingLeft: '3px', paddingRight: '2px' }}>{value || ''}</div>
);

export const CellActive = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <>
      {value ? (
        <div className="text-center text-success font-weight-bold">{t('Yes')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('No')}</div>
      )}
    </>
  );
};

export const CellCenter = ({ cell: { value } }) => <div className="text-center">{value || ''}</div>;

export const CellLeft = ({ cell: { value } }) => <div className="text-start">{value || ''}</div>;

export const CellRight = ({ cell: { value } }) => <div className="text-end">{value || ''}</div>;

export const CellPercent = ({ cell: { value } }) => {
  //<div className="text-center">{`${parseFloat(value).toFixed(2)} %`}</div>
  // pad to 10 chars FIGURE SPACE = &numsp; U+2007
  let txt = parseFloat(value).toFixed(2);
  txt = '\u2007'.repeat(6 - txt.length) + txt;
  return <div className="text-center">{`${txt} %`}</div>;
};

export const CellDate = ({ cell: { value } }) => (
  <div className="text-center">{value ? format(parseISO(value), 'dd/MM/yyyy') : ''}</div>
);

export const CellDateTime = ({ cell: { value } }) => (
  <div className="text-center">{value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : ''}</div>
);

export const CellNoActive = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <>
      {!value ? (
        <div className="text-center text-success font-weight-bold">{t('No')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('Yes')}</div>
      )}
    </>
  );
};

export const CellYesNo = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {value ? (
        <div className="text-center text-success font-weight-bold">{t('Yes')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('No')}</div>
      )}
    </div>
  );
};

// Reverse Value
export const CellReverseYesNo = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {!value ? (
        <div className="text-center text-success font-weight-bold">{t('Yes')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('No')}</div>
      )}
    </div>
  );
};

// Reverse Colors
export const CellYesNoReverseColors = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {value ? (
        <div className="text-center text-danger font-weight-bold">{t('Yes')}</div>
      ) : (
        <div className="text-center text-success font-weight-bold">{t('No')}</div>
      )}
    </div>
  );
};

export const CellOkError = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {value ? (
        <div className="text-center text-success font-weight-bold">{t('OK')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('ERROR')}</div>
      )}
    </div>
  );
};

export const CellYesNoNull = ({ cell: { value } }) => {
  const { t } = useTranslation();
  return (
    <div className="text-center">
      {value === null ? (
        <div className="text-center font-weight-bold">{t('null')}</div>
      ) : value ? (
        <div className="text-center text-success font-weight-bold">{t('Yes')}</div>
      ) : (
        <div className="text-center text-danger font-weight-bold">{t('No')}</div>
      )}
    </div>
  );
};

export function CellIntCustom(numberWidth: number) {
  return ({ cell: { value } }) => {
    let txt = '-';
    if (typeof value === 'string') {
      const i = parseInt(value, 10);
      if (isNaN(i)) txt = value;
      else txt = i.toLocaleString();
    } else if (typeof value === 'number') {
      txt = value.toLocaleString();
    }
    // pad to 10 chars FIGURE SPACE = &numsp; U+2007
    txt = '\u2007'.repeat(numberWidth - txt.length) + txt;
    return <div className="text-center">{txt}</div>;
  };
}

export function CellFloatCustom(
  numberWidth: number,
  decimalsDigits: number,
  noTrailingZeros = false,
) {
  return ({ cell: { value } }) => {
    let txt = '-';
    if (typeof value === 'string') {
      const i = parseFloat(value);
      if (isNaN(i)) txt = value;
      else {
        //txt = i.toLocaleString();
        txt = i.toLocaleString(undefined, {
          minimumFractionDigits: decimalsDigits,
          maximumFractionDigits: decimalsDigits,
        });
      }
    } else if (typeof value === 'number') {
      txt = value.toLocaleString(undefined, {
        minimumFractionDigits: decimalsDigits,
        maximumFractionDigits: decimalsDigits,
      });
    }
    // pad to 10 chars FIGURE SPACE = &numsp; U+2007
    //console.log(value, numberWidth, txt.length);
    if (numberWidth > txt.length) txt = '\u2007'.repeat(numberWidth - txt.length) + txt;

    // Χωρίς Μηδενικά στο Τέλος
    if (noTrailingZeros) {
      // i.e. 1.20 -> 1.2  & 1.00 -> 1
      if (txt.slice(-3) === '.00')
        txt = txt.substring(0, txt.length - 3) + '\u2008' + '\u2007' + '\u2007';
      if (txt.slice(-1) === '0') txt = txt.substring(0, txt.length - 1) + '\u2007';
    }

    return <div className="text-center">{txt}</div>;
  };
}

export const CellFloat = () => {
  return CellFloatCustom(10, 2, true);
};
export const CellInt = () => {
  return CellIntCustom(10);
};
